module.exports = __webpack_public_path__ + "static/media/logo.386cfea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo.png
// module id = 84
// module chunks = 0